import { base } from 'api';
import {
  SearchStickerHolderQueryType,
  StickerUpdateType,
  StickerUserIdsType,
} from 'types';

const PATH = '/stickers';

const getAll = () => base.get(PATH);

const get = (id: number) => base.get(`${PATH}/${id}`);

const put = ({ id, ...data }: StickerUpdateType) =>
  base.put(`${PATH}/${id}`, data);

const getHolders = (id: number, query: SearchStickerHolderQueryType) =>
  base.get(`${PATH}/${id}/users`, { params: { ...query } });

const grant = ({ id, userIds }: StickerUserIdsType) =>
  base.post(`${PATH}/${id}/grant`, { userIds });

const revoke = ({ id, userIds }: StickerUserIdsType) =>
  base.post(`${PATH}/${id}/revoke`, { userIds });

export { get, getAll, put, getHolders, grant, revoke };
